import {
  ConditionalExpression,
  EvaluateableExpression,
  Let,
  OPERATORS,
} from '@jetfabric/schemas/lib/protocol-sdk-api-v2/query/condition';
import {
  DataReference,
  VariableReference,
} from '@jetfabric/schemas/lib/protocol-sdk-api-v2/query/data-reference';

export const validOperatorHeads: Set<string> = new Set(Object.values(OPERATORS));

export const isNonEmptyArray = (val: any) => Array.isArray(val) && val.length > 0;

export function isLet(expression: ConditionalExpression): expression is Let {
  return (
    expression !== null &&
    typeof expression === 'object' &&
    'body' in (expression as any) &&
    'bindings' in (expression as any)
  );
}

export function isEvaluateableExpression(
  expression: ConditionalExpression
): expression is EvaluateableExpression {
  return isNonEmptyArray(expression) && validOperatorHeads.has((expression as [string])[0]);
}

export function isDataReference(value: any): value is DataReference {
  return typeof value === 'object' && value !== null && 'query' in value;
}

export function isVariableReference(value: any): value is VariableReference {
  return typeof value === 'object' && value !== null && 'variable' in value;
}
